/**
 * briefing-mock.ts — Portfolio-mini KPI placeholders for the Heute Briefing
 * (Story UI-U10, AC2).
 *
 * There is NO portfolio-KPI-for-briefing endpoint yet, so — exactly like the
 * Dashboard's endpoint-less blocks (heute-mock.ts) — these render in MOCK mode from
 * here and are replaced by a design-conform empty line in LIVE mode. The Entscheid
 * TILE counts, by contrast, DO come from a live read (GET /agent/briefing).
 */
import type { BadgeVariant } from '../../components/ui/Badge';

export interface BriefingKpi {
  label: string;
  /** Rendered in mono-num (money / counts / durations). */
  value: string;
  /** Optional delta chip, e.g. "+4.2%". null → no chip. */
  delta: string | null;
  /** Soft-badge tone for the delta chip. */
  deltaTone: BadgeVariant;
}

export const BRIEFING_KPIS: BriefingKpi[] = [
  { label: 'Prämienvolumen', value: "CHF 612'000", delta: '+4.2%', deltaTone: 'success' },
  { label: 'Aktive Policen', value: '209', delta: '+6', deltaTone: 'success' },
  { label: 'Offene Aufgaben', value: '14', delta: null, deltaTone: 'neutral' },
  { label: 'Ø Bearbeitungszeit', value: '2.4 Tage', delta: '−0.3', deltaTone: 'success' },
];
